import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import AddCarouselSlider from "../pages/Home/BannerCarousel/AddCarouselSlider/AddCarouselSlider";
import CarouselListing from "../pages/Home/BannerCarousel/CarouselListing/CarouselListing";
import BookList from "../pages/Home/Book/BookListing/BookListing";
import AddBook from "../pages/Home/Book/AddNewBook/AddNewBook";
import ManageAccess from "../pages/Home/ManageAccess/ManageAccess";
import BlogListing from "../pages/Home/Blog/BlogListing/BlogListing";
import AddNewBlogs from "../pages/Home/Blog/AddNewBlogs/AddNewBlogs";
import Locations from "../pages/Home/Miscellaneous/Locations/Locations";
import Languages from "../pages/Home/Miscellaneous/Languages/Languages";
import Sectors from "../pages/Home/Miscellaneous/Sectors/Sectors";
import Categories from "../pages/Home/Miscellaneous/Categories/Categories";
import AboutUsList from "../pages/Home/AboutUs/AboutUsListing";
import Add from "../pages/Home/AboutUs/AddAboutUs/Add";
import Sidebar from "./Sidebar/Sidebar";
import PageLayout from "../Layout/PageLayout/PageLayout";
import Auth from "../pages/Auth";
import ForgotPassword from "../pages/Auth/forgotPassword";
import { useAuth } from "./middleware";
import TirthForm from "../pages/Home/Tirth/AddNewTirth/AddNewTirth";
import TirthListing from "../pages/Home/Tirth/TirthListing/TirthListing";
import PrivacyPolicyList from "../pages/Home/PrivacyPolicy/PrivacyPolicyList/PrivacyPolicyList";
import TermsConditionList from "../pages/Home/TermsCondition/TermsConditionListing/TermsConditionList";
import PrivacyPolicyAdd from "../pages/Home/PrivacyPolicy/PrivacyPolicyAdd/PrivacyPolicyAdd";
import TermsConditionAdd from "../pages/Home/TermsCondition/TermsConditionAdd/TermsConditionAdd";
import Authors from "../pages/Home/Authors/Authors";

const RouterWrapper = () => {
  const { token } = useAuth();

  const routePaths = [
    {
      path: "/login",
      element: <Auth />,
      isPrivate: false,
      exact: true,
      isLogin: true,
    },
    {
      path: "/",
      exact: true,
      isPrivate: true,
      element: <BookList />,
    },

    {
      path: "/pages/about-us",
      exact: true,
      isPrivate: true,
      element: <AboutUsList />,
    },
    {
      path: "/about-us/add",
      exact: true,
      isPrivate: true,
      element: <Add />,
    },
    {
      path: "/about-us/edit/:id",
      exact: true,
      isPrivate: true,
      element: <Add />,
    },
    {
      path: "/banner/list",
      exact: true,
      isPrivate: true,
      element: <CarouselListing />,
    },
    {
      path: "/banner/add",
      exact: true,
      isPrivate: true,
      element: <AddCarouselSlider />,
    },
    {
      path: "/banner/edit/:id",
      exact: true,
      isPrivate: true,
      element: <AddCarouselSlider />,
    },
    {
      path: "/book/list",
      exact: true,
      isPrivate: true,
      element: <BookList />,
    },
    {
      path: "/book/add",
      exact: true,
      isPrivate: true,
      element: <AddBook />,
    },
    {
      path: "/book/edit/:slug",
      exact: true,
      isPrivate: true,
      element: <AddBook />,
    },
    {
      path: "/article/list",
      exact: true,
      isPrivate: true,
      element: <BookList />,
    },
    {
      path: "/article/add",
      exact: true,
      isPrivate: true,
      element: <AddBook />,
    },
    {
      path: "/article/edit/:slug",
      exact: true,
      isPrivate: true,
      element: <AddBook />,
    },
    {
      path: "/blog/edit/:slug",
      exact: true,
      isPrivate: true,
      element: <AddNewBlogs />,
    },
    {
      path: "/blog/add",
      exact: true,
      isPrivate: true,
      element: <AddNewBlogs />,
    },
    {
      path: "/blog/list",
      exact: true,
      isPrivate: true,
      element: <BlogListing />,
    },
    {
      path: "/users",
      exact: true,
      isPrivate: true,
      element: <ManageAccess />,
    },
    {
      path: "/miscellaneous/categories",
      element: <Categories />,
      isPrivate: true,
      exact: true,
    },
    {
      path: "/miscellaneous/sectors",
      element: <Sectors />,
      isPrivate: true,
      exact: true,
    },
    {
      path: "/miscellaneous/languages",
      element: <Languages />,
      isPrivate: true,
      exact: true,
    },
    {
      path: "/miscellaneous/locations",
      element: <Locations />,
      isPrivate: true,
      exact: true,
    },
    {
      path: "/",
      element: <Auth />,
      isPrivate: false,
      exact: true,
    },
    {
      path: "/forgot-password",
      element: <ForgotPassword />,
      isPrivate: false,
      exact: true,
    },
    {
      path: "/tirth/add",
      element: <TirthForm />,
      isPrivate: true,
      exact: true,
    },

    {
      path: "/tirth/list",
      element: <TirthListing />,
      isPrivate: true,
      exact: true,
    },
    {
      path: "/tirth/edit/:slug",
      exact: true,
      isPrivate: true,
      element: <TirthForm />,
    },
    {
      path: "/pages/privacy-policy",
      exact: true,
      isPrivate: true,
      element: <PrivacyPolicyList />,
    },
    {
      path: "/pages/policy/add",
      exact: true,
      isPrivate: true,
      element: <PrivacyPolicyAdd />,
    },

    {
      path: "/pages/terms-condition",
      exact: true,
      isPrivate: true,
      element: <TermsConditionList />,
    },
    {
      path: "/pages/terms-condition/add",
      exact: true,
      isPrivate: true,
      element: <TermsConditionAdd />,
    },
    {
      path: "/authors",
      exact: true,
      isPrivate: true,
      element: <Authors />,
    },
  ];

  const RouteGuard = ({ token, isPrivate, children, isLogin = false }) => {
    if (isPrivate && !token) return <Navigate to="/login" replace />;
    if (isLogin && token) return <Navigate to="/" replace />;
    return children;
  };

  return (
    <Router>
      {token && <Sidebar />}
      <PageLayout>
        <Routes>
          {routePaths.map((n, i) => (
            <Route
              key={i}
              path={n.path}
              element={
                <RouteGuard
                  token={token}
                  isPrivate={n.isPrivate}
                  isLogin={n?.isLogin ?? false}
                >
                  {n.element}
                </RouteGuard>
              }
            />
          ))}
        </Routes>
      </PageLayout>
    </Router>
  );
};
export default RouterWrapper;
